import type { ReactCodeMirrorProps } from '@uiw/react-codemirror';
import type React from 'react';
import { lazy } from 'react';
import { LazyDependency } from './LazyDependency.tsx';

// type-only import, erased at build time — does not pull CodeMirror into this chunk
export type CodeEditorProps = Omit<ReactCodeMirrorProps, 'extensions' | 'theme'> & {
  mode: 'hl7' | 'zplOrderLabel' | 'zplDoctorLabel';
};

const LazyCodeEditorImpl = lazy(() => import('./CodeEditorImpl.tsx'));

/**
 * CodeMirror is ~390 kB and only used on a handful of admin screens and the HL7 preview,
 * so it is loaded on demand. Props are forwarded verbatim, which keeps the antd Form.Item
 * value/onChange injection working.
 */
export const CodeEditor: React.FC<CodeEditorProps> = props => (
  <LazyDependency height={typeof props.height === 'string' ? props.height : undefined}>
    <LazyCodeEditorImpl {...props} />
  </LazyDependency>
);
